import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import aedIcon from '../assets/images/AED.png';
import calendarIcon from '../assets/images/calendar-icon.png'
import shieldIcon from '../assets/images/shield-icon.png'
import upgradeIcon from '../assets/images/upgrade-icon.png'
import moment from 'moment/moment';
import { StateUseContext } from '../context/UserDetailContext';
import VanSubsAmazonPay from '../components/PaymentGateways/VanSubsAmazonPay';
import VanSubsNGenius from '../components/PaymentGateways/VanSubsNGenius';
import VanCCAvenue from '../components/PaymentGateways/VanCCAvenue';
import VanSubscriptionTransactions from '../components/vansubscription/VanSubscriptionTransactions';
import TotalFeeSection from '../components/vansubscription/TotalFeeSection';

const VanSubscription = () => {
    const { userDetail, vanSubscriptionDetail, fetchVanSubscriptionDetail, vanSubscriptionPlans, fetchVanSubscriptionPlans } = StateUseContext()
    const { subscriptionDetail, payment_gateway } = vanSubscriptionDetail || {};
    const { subscription_plan } = vanSubscriptionPlans || {}
    const [subsFeeDetail, setSubsFeeDetail] = useState({});
    const [subscriptionPlan, setSubscriptionPlan] = useState('');
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [lumpsumCheck, setLumpsumCheck] = useState(true);
    const [installmentCheck, setInstallmentCheck] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            try {
              await Promise.all([
                fetchVanSubscriptionDetail(),
                fetchVanSubscriptionPlans()
              ]);
            } catch (error) {
              console.error('Error fetching subscription data:', error);
            } 
          };
          fetchData();
    }, [])

    // console.log('subscription_plan..',subscription_plan)
    const lumpsum = subscription_plan?.find(data => data?.subscription_type === 100) || {};
    const installment = subscription_plan?.filter(data => data?.subscription_type !== 100) || [];
    const isInstallmentPaid = installment?.find(data => data?.van_ispaid === 1? true : false);


    const handleCheckboxChange = () => {
        setShowPaymentOptions(!showPaymentOptions)
    }

    const installmentHandler = (instData, payType) => {
        if (!instData) return;
        const { amount, id, student_id, subscription_type, subscriptions_id } = instData || {}
        if (payType === 1) {
            // Installment
            setLumpsumCheck(false)
            setInstallmentCheck(true)
            setSubscriptionPlan(true)
        }
        if (payType === 2) {
            // lumpsum
            setLumpsumCheck(true)
            setInstallmentCheck(false)
            setSubscriptionPlan(true)
        }

        setSubsFeeDetail({ amount, id, student_id, subscription_type, subscriptions_id, pay_type: payType })
    }

    let superscriptData = ['', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th']

    return (
        <>


            <div className="container  mt-4">
                <div className="row border-bottom align-items-center">
                    <div className="col-6">
                        <h2 className='fs-lg-4 fs-5 fw-bold'>Van Subscription</h2>
                    </div>
                    <div className="col-6 text-end">
                        <Link to={'/student/dashboard'} className='go-to-dashLink text-secondary my-2 px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none'>Go To Dashboard</Link>
                    </div>
                </div>
            </div>

            <div className="container van_features text-center mt-5">
                <h3 className='fw-bold'>With our Transport System, you will have:</h3>
                <div className="row">
                    <div className="col-lg-10 mx-auto">
                        <div className="row g-4 mt-4">
                            <div className="col-6 col-md-3">
                                <div className="transport_feature">
                                    <img src={aedIcon} alt="icon" />
                                    <p>A flexible pricing model that suits your needs.</p>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="transport_feature">
                                    <img src={calendarIcon} alt="icon" />
                                    <p>Reminders for timely payments.</p>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="transport_feature">
                                    <img src={shieldIcon} alt="icon" />
                                    <p>Multiple payment options.</p>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="transport_feature">
                                    <img src={upgradeIcon} alt="icon" />
                                    <p>Simply upgrade your price plan, when needed.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {subscriptionDetail?.start_date && (
                    <div className="row mt-4">
                        <div className="col-lg-10 mx-auto">
                            <VanSubscriptionTransactions subscriptionDetail={subscriptionDetail} />
                        </div>
                    </div>
                )}


                <div className="row  mb-5 van_subs_formWrap">
                    <div className="col-lg-10 mx-auto mb-4 mt-3 text-center">
                        <h3 className='fw-bold'>{subscriptionDetail?.start_date ? 'Want to Upgrade Your Plan?' : 'Want a smooth journey experience?'}</h3>
                    </div>

                    {Object.keys(subscriptionDetail ||{})?.length > 0 && (
                        <div className="col-md-10 mx-auto">
                            <TotalFeeSection subscriptionDetail={subscriptionDetail || {}}/>
                        </div>
                    )}
                    
                    <div className="col-lg-10 mx-auto ">
                        <div className="row align-items-center gx-md-5 gy-4 ">
                            
                            {/* Van Form */}
                            
                                <div className="col-md-10 text-start payment_methods_contain">
                                {subscription_plan?.length > 0 ? (
                                    <>
                                        <div className="choose_fee_options flex-wrap mt-2">
                                            <h6 className="mt-3 mb-3 d-block w-100">Choose Payment Options</h6>
                                            {Object.keys(isInstallmentPaid || {}).length <= 0 && (
                                                    <div className={`label lump_sum_label mb-3 ${lumpsum?.van_ispaid === 1 ? 'lumpsum_paid' : ''}`}>
                                                    <h5>Lumpsum Payment Plan</h5>
                                                    <div className={`payment_plan_amount  ${lumpsumCheck ? 'lumpsum_active' : ''} ${(lumpsum?.van_ispaid === 1 && lumpsum?.verified === 0) ? 'approval_pending_box' : ''} ${lumpsum.van_ispaid === 1 && lumpsum.verified === 1 ? 'paid_installment' : ''}`}
                                                        onClick={e => {
                                                            installmentHandler(lumpsum, 2);
                                                            // setPayType(1);
                                                        }}>
                                                        <p>Lumpsum Amt.</p>
                                                        <h3>{lumpsum.amount} AED</h3>
                                                        {lumpsum?.due_date && <small>Due Date - {moment(lumpsum?.due_date).format("DD-MM-YYYY")}</small>}
                                                        {(lumpsum?.verified === 0 || lumpsum?.verified === 1) && <h6 className={`mt-1 ${(lumpsum?.van_ispaid === 1 && lumpsum?.verified === 0) ? 'approval_pending' : ''}`}>{(lumpsum?.van_ispaid === 1 && lumpsum?.verified === 1) && 'Paid'} {(lumpsum?.van_ispaid === 1 && lumpsum?.verified === 0) && 'Approval Pending'}</h6>}
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {lumpsum?.van_ispaid !== 1 && (
                                                <div className="label installment_label">
                                                    <h5>Installment Payment Plan</h5>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {installment?.map((item, index) => {
                                                            let shouldApplyClass = false;
                                                            if (index === 0) {
                                                                shouldApplyClass = ((item?.van_ispaid === 0 && item?.verified === 0) || (item?.van_ispaid === 0 && item?.verified === 2));
                                                            }
                                                            else if (
                                                                (item?.van_ispaid === 1 || item?.verified === 0) &&
                                                                ((installment !== undefined && installment[index - 1].van_ispaid === 1) && (installment !== undefined && installment[index - 1].verified === 1))
                                                            ) {

                                                                shouldApplyClass = (item.van_ispaid === 0 && item.verified === 0);
                                                            }

                                                            return (
                                                                <div key={index} onClick={shouldApplyClass ? () => installmentHandler(item, 1) : undefined}
                                                                    className={`payment_plan_amount ${installmentCheck ? 'installment_active' : ''} installment_default ${(item?.van_ispaid === 1 && item?.verified === 0) ? 'approval_pending_box' : ''} 
                                                                    ${shouldApplyClass ? 'active_installment' : ''} ${item.van_ispaid === 1 && item.verified === 1 ? 'paid_installment' : ''}`}>
                                                                    <p>{item.installment_number}<sup>{superscriptData[item.installment_number]}</sup> Installment Amt.</p>
                                                                    <h3>{parseFloat(item.amount).toFixed(1)} AED</h3>
                                                                    {item?.due_date && <small>Due Date - {moment(item?.due_date).format("DD-MM-YYYY")}</small>}
                                                                    {(item?.verified === 0 || item?.verified === 1) && <h6 className={`mt-1 ${(item?.van_ispaid === 1 && item?.verified === 0) ? 'approval_pending' : ''}`}>{(item?.van_ispaid === 1 && item?.verified === 1) && 'Paid'} {(item?.van_ispaid === 1 && item?.verified === 0) && 'Approval Pending'}</h6>}
                                                                </div>

                                                            )
                                                        })}

                                                    </div>
                                                </div>
                                            )}

                                        </div>

                                        <div className="form-check mt-4 pt-1 mb-3">
                                            <input className="form-check-input" disabled={!subscriptionPlan} type="checkbox" onChange={handleCheckboxChange} checked={showPaymentOptions} id="showPayment_Options" />
                                            <label className="form-check-label mb-1" htmlFor="showPayment_Options">
                                                I have read the company’s <a href='https://www.allenoverseas.com/refund-cancellation/' rel="noreferrer" target="_blank" className="text-decoration-underline"> refund policy</a>
                                            </label>
                                            <div className='text-muted small'>(To enable payment options please accept our company's refund policy)</div>
                                        </div>

                                        {/* Payment gateways */}
                                        <div className={` payment_methods mt-3 ${(showPaymentOptions && subscriptionPlan) ? 'enable_payments' : ''}`}>
                                            {payment_gateway?.length > 0 ?
                                                payment_gateway?.map((item) => (
                                                    <React.Fragment key={item.id}>
                                                        {item.name === 'N-Genius' &&
                                                            <VanSubsNGenius
                                                                
                                                                paymentConfig={item}
                                                                subsFeeDetail={subsFeeDetail}
                                                                userDetail={userDetail}
                                                            />
                                                        }
                                                        {item.name === 'Amazon payment services' &&
                                                            <VanSubsAmazonPay
                                                                
                                                                paymentConfig={item}
                                                                subsFeeDetail={subsFeeDetail}
                                                                userDetail={userDetail}
                                                            />
                                                        }
                                                        {item?.name?.toLowerCase()?.includes('ccavenue') &&
                                                            <VanCCAvenue
                                                                paymentConfig={item}
                                                                subsFeeDetail={subsFeeDetail}
                                                                userDetail={userDetail}
                                                            />
                                                        }
                                                    </React.Fragment>
                                                )
                                                )
                                                : <h5 className='text-center'>No Payment Gateway Found</h5>
                                            }
                                        </div>

                                    </>
                                ): <p className='text-center fw-bold'>Loading...</p>}
                                </div>
                            

                        </div>
                    </div>

                </div>



            </div>


        </>
    )
}

export default VanSubscription